import { useQuery } from '@tanstack/react-query';
import { getMyAlertsCountOptions } from './my-alerts-count';
import { getMyAlertsListOptions } from './alerts';

export const useMyAlertsCount = (isLoggedIn: boolean) =>
  useQuery(getMyAlertsCountOptions(isLoggedIn));

export const useMyAlerts = (isLoggedIn: boolean) =>
  useQuery(getMyAlertsListOptions(isLoggedIn));
